export class LoginRequest {
    username?: string;
    password?: string;
    code?: string;
}

export class RegisterRequest {
    firstName?: string;
    lastName?: string;
    username?: string;
    password?: string;
    phoneNumber?: string;
    displayName?: string;
    fromCBS: boolean;
    imgUrl: string;

    constructor(request?: Partial<RegisterRequest>) {
        Object.assign(this, request);
    }
}

export interface ISocialLoginRequest {
    token: string;
    provider: string;
    code?: string;
    terms?: boolean;
    profile?: RegisterRequest;
    communityId?: number;
}
